import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML } from '@as-react/common-utils';
import { availableComponents, renderingTools } from '../../../index';
import { Logger } from '@as-react/logger';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { Hydrater } from '@as-react/hydrater';
import { useAemConfig } from '@as-react/common-components';
export const RowBanner = ({ content }) => {
    const containerEl = useRef(null);
    const { i18n } = useTranslation();
    const { locale, translationLang, version: aemVersion } = useAemConfig();
    useEffect(() => {
        !!containerEl.current &&
            Hydrater({
                availableComponents,
                root: containerEl.current,
                renderingTools,
                locale,
                translationLang,
                aemVersion,
                i18n,
            }).catch(Logger.logError);
    }, []);
    return (_jsx("div", { ref: containerEl, "data-testid": "row-banner", children: _jsx(HtmlInclude, { htmlFragment: unescapeHTML(content) }) }));
};
